var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"blackCardDiscout",attrs:{"href":_vm.location}},[_vm._m(0),_c('span',{staticClass:"checkDetail"},[_vm._v("查看详情")]),_c('i',{staticClass:"arrow"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b',[_vm._v("途牛黑卡会员")]),_c('i',{staticClass:"dot"},[_vm._v(".")]),_c('span',[_vm._v("尊享"),_c('i',[_vm._v("1%")]),_vm._v("立减优惠")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4f639b4","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/blackCardDiscout.vue
// module id = 711
// module chunks = 0